import React, { useState, useEffect, PropTypes } from "react"
import Autosuggest from 'react-autosuggest';
import _ from "lodash"
import axios from 'axios';
// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => `${suggestion.area} ${(suggestion.location)? `(${suggestion.location})` : ''}`;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
   {`${suggestion.area} ${(suggestion.location)? `(${suggestion.location})` : ''}`}
  </div>
);




class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: [],
      areas: [],
      aliasVal:"",
      isChages: false
    };
  }

  onChange = (event, { newValue }) => { 
    this.setState({
      value: newValue,
      aliasVal: newValue,
      isChages: true
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  suggestionSelected = (e, {suggestion})=>{ 
   
    if(suggestion){ 
      this.setState({
        value: `${suggestion.area} ${(suggestion.location)? `(${suggestion.location})` : ''}`,
        aliasVal: suggestion.alias,
      });
    }
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getitems = async url => {
    try {
      const { data } = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
            }})
      this.setState({ areas: data })
    } catch (error) {
      console.error(error)
    }
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const areasToUse = this.state.areas.length > 0 ? this.state.areas : this.props.areas;

    return inputLength === 0 ? [] : areasToUse.filter(area =>
      area.area.toLowerCase().slice(0, inputLength) === inputValue
    );
  };
  
  componentDidUpdate(prevProps) {
    if (prevProps.areas !== this.props.areas) {
      this.setState({ areas: this.props.areas })
    }
  }

  render() {
    const { value, suggestions, isChages, aliasVal } = this.state;

    // Autosuggest will pass through all these props to the input.
    var setVal = value;
    if (_.isEmpty(setVal) && !isChages) {
      //setVal = this.props.areaVal;
    }

    const inputProps = {
      placeholder: 'Area or project name',
      value: setVal,
      onChange: this.onChange
    };

    // Finally, render it!
    return (
      <div className="form-group autosuggest_container">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          onSuggestionSelected={this.suggestionSelected}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}      

        />
        <input type="hidden" className="searchVal" value={aliasVal}/>
      </div>
    );
  }
}

export default SearchBox;
